import { render, staticRenderFns } from "./TeacherListTable.vue?vue&type=template&id=2c096f3e&scoped=true&lang=pug"
import script from "./TeacherListTable.vue?vue&type=script&lang=ts"
export * from "./TeacherListTable.vue?vue&type=script&lang=ts"
import style0 from "./TeacherListTable.vue?vue&type=style&index=0&id=2c096f3e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c096f3e",
  null
  
)

export default component.exports